<div class="dialog-container" [class.dragover]="dragOver" [class.uploading]="uploading">
    <h1 class="condensed dialog-title" mat-dialog-title>Asfaltlijst importeren</h1>
    <div class="dialog-content mt-3" mat-dialog-content>
        <form [formGroup]="form">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Naam van de Molen</mat-label>
                <input
                    [matAutocomplete]="auto"
                    aria-label="Number"
                    formControlName="name"
                    matInput
                    placeholder="Naam"
                    type="text" />
                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                    @for (mill of asphaltMills; track mill) {
                        <mat-option [value]="mill.name">
                            {{ mill.name }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            @if (file) {
                <div>
                    <b>Geüpload bestand:</b> {{ file.name }}
                    <br />
                </div>
            }
        </form>
        <div>
            @if (!file) {
                Geen bestand toegevoegd
            }
            <button class="p-0 px-1" color="primary" mat-button>
                <label class="p-1 mt-0 me-0 mb-0">
                    Bestand {{ file ? 'wijzigen' : 'uploaden' }}
                    <input (change)="selectFile($event)" hidden multiple type="file" />
                </label>
            </button>
        </div>
    </div>
    <div class="d-flex flex-wrap" mat-dialog-actions>
        <button [mat-dialog-close]="false" mat-button>Annuleren</button>
        <div class="spacer"></div>
        <button
            [disabled]="saving || !form.valid || !file"
            (click)="import()"
            cdkFocusInitial
            color="primary"
            mat-raised-button>
            Importeren
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    </div>
    <div class="overlay">
        <div class="overlay-wrapper drag">
            <div class="upload-icon">
                <i class="fas fa-upload"></i>
            </div>
        </div>
        <div class="overlay-wrapper uploading">
            <div class="upload-icon">
                <i class="fas fa-circle-notch fa-spin"></i>
            </div>
            <div>Bezig met importeren...</div>
        </div>
    </div>
</div>
